import { render, staticRenderFns } from "./MainProjectSectionListTab.vue?vue&type=template&id=3f7a2f4d&scoped=true&"
import script from "./MainProjectSectionListTab.vue?vue&type=script&lang=ts&"
export * from "./MainProjectSectionListTab.vue?vue&type=script&lang=ts&"
import style0 from "./MainProjectSectionListTab.vue?vue&type=style&index=0&id=3f7a2f4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a2f4d",
  null
  
)

export default component.exports